export default {"src":"/_next/static/media/user-inplay.6169ac1d.svg","height":14,"width":14};